import React, {Component} from 'react';
import {ListGroupItem} from "reactstrap";
import {FaUsers} from "react-icons/fa";
import {connect} from 'react-redux';

class LoginPageCustomerComponent extends Component {

    LoginPageCustomer = async () => {
        await this.props.updatePageAdmin({ isMenuAdmin: true });
        let user = this.props.user;
        user.role = 'user';
        let itemUser = {
            user: user,
            menu: 'user',
            sessionRole: 'user',
            credit: this.props.credit,
        }

        await this.props.saveUser(itemUser);
        await this.props.redirectCustomer();
    }

    render() {
        return (
            <ListGroupItem tag="button" action className="border-light" onClick={ () => this.LoginPageCustomer() }>
                <FaUsers /> Đăng nhập trang khách hàng
            </ListGroupItem>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        user: state.user.user,
        credit: state.user.credit,
        sessionAdmin: state.infoAdmin.isAdmin,
        userAdminId: state.infoAdmin.userId,
        isMenuAdmin: state.infoAdmin.isMenuAdmin,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        updatePage: (item) => {
            dispatch(({ type : 'updatePage', item }))
        },
        updatePageAdmin: (item) => {
            dispatch(({ type : 'updatePageAdmin', item }))
        },
        saveUser: (item) => {
            dispatch(({ type : 'saveUser', item }))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPageCustomerComponent);